import { Grid } from "@material-ui/core";
import { functions } from "config/firebaseConfig";
import { Form, Formik } from "formik";
import { useSnackbar } from "notistack";
import React from "react";
import { LOGIN_ERROR_MESSAGES } from "redux/reducers/authReducer";
import {
    BoxCard,
    InputFieldFormik,
    SubmitButton,
    Subtitle,
} from "ui/componentes";
import {
    yupInvalidEmail,
    yupRequiredField,
} from "ui/componentes/Form/functions/validationMessages";
import * as Yup from "yup";

const initialValues = {
    email: "",
    firstName: "",
    lastName: "",
    displayName: "",
    initials: "",
    driverInfo: {
        iracingId: "",
    },
};

const UserValidation = Yup.object().shape({
    firstName: Yup.string().required(yupRequiredField),
    lastName: Yup.string().required(yupRequiredField),
    email: Yup.string().required(yupRequiredField).email(yupInvalidEmail),
});

const UserForm = () => {
    const { enqueueSnackbar } = useSnackbar();
    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={UserValidation}
            onSubmit={(user, { setSubmitting, resetForm }) => {
                user.displayName = `${user.firstName} ${user.lastName}`;
                functions
                    .httpsCallable("user-createUser")(user)
                    .then(() => {
                        enqueueSnackbar("Usuário adicionado!", {
                            variant: "success",
                        });
                        resetForm();
                        setSubmitting(false);
                    })
                    .catch((error) => {
                        console.error(error.code);
                        enqueueSnackbar(
                            LOGIN_ERROR_MESSAGES[error.code] ||
                                "Erro ao adicionar usuário!",
                            { variant: "error" }
                        );
                        setSubmitting(false);
                    });
            }}
        >
            {({ errors, touched }) => (
                <Form>
                    <BoxCard>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Subtitle text="Usuário" />
                            </Grid>
                            <Grid item xs={12}>
                                <InputFieldFormik
                                    required
                                    autoFocus
                                    id="firstName"
                                    name="firstName"
                                    label="Nome"
                                    error={
                                        !!errors.firstName && touched.firstName
                                    }
                                    helperText={
                                        touched.firstName
                                            ? errors.firstName
                                            : ""
                                    }
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <InputFieldFormik
                                    required
                                    id="lastName"
                                    name="lastName"
                                    label="Sobrenome"
                                    error={
                                        !!errors.lastName && touched.lastName
                                    }
                                    helperText={
                                        touched.lastName ? errors.lastName : ""
                                    }
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <InputFieldFormik
                                    required
                                    id="email"
                                    name="email"
                                    label="Email"
                                    error={!!errors.email && touched.email}
                                    helperText={
                                        touched.email ? errors.email : ""
                                    }
                                />
                            </Grid>
                            <InputFieldFormik
                                id="driverInfo.iracingId"
                                type="number"
                                name="driverInfo.iracingId"
                                label="iRacing ID"
                            />
                            <Grid item xs={12}>
                                <SubmitButton fullWidth>
                                    Adicionar Usuário
                                </SubmitButton>
                            </Grid>
                        </Grid>
                    </BoxCard>
                </Form>
            )}
        </Formik>
    );
};

export { UserForm };
